import { ReportField } from '../models/reportField';
import { SideNavCategory } from '../components/side-nav';
import {
  createReportFieldKey,
  formatSubCategoryName,
  insertSorted,
} from '../util';

const comparer = (a: SideNavCategory, b: SideNavCategory): number =>
  a.name?.localeCompare(b.name);

export function mapFieldToCategory(
  reportFields: ReportField[],
): SideNavCategory[] {
  const categories: SideNavCategory[] = [];
  const allFieldsToSearch: SideNavCategory[] = [];
  const allCategories: SideNavCategory[] = [];
  const itemMap = new Map<string, SideNavCategory>();

  const customFieldSubCategory: SideNavCategory = {
    key: 'CustomFields - All',
    name: 'Custom Fields',
    items: [],
    formattedSearchText: 'Custom Fields',
  };
  const customFieldsCategory: SideNavCategory = {
    key: 'CustomFields',
    name: 'Custom Fields',
    items: [customFieldSubCategory],
  };

  reportFields.forEach((reportField) => {
    const reportFieldKey = createReportFieldKey(reportField);
    // check if this is custom field
    if (reportField.isClientCustom) {
      const customField: SideNavCategory = {
        key: reportFieldKey,
        name: reportField.fieldName,
        tag: reportField,
      };

      customFieldSubCategory.items.push(customField);
      insertSorted(allCategories, customField, comparer);
      return;
    }

    const categoryKey = reportField.category;
    let category = itemMap.get(categoryKey);

    if (!category) {
      category = {
        name: reportField.category,
        key: categoryKey,
        items: [],
      };
      insertSorted(categories, category, comparer);
      insertSorted(allFieldsToSearch, category, comparer);
      itemMap.set(categoryKey, category);
    }

    const subCategoryKey = `${categoryKey}-${reportField.subcategory}`;
    let subCategory = itemMap.get(subCategoryKey);

    if (!subCategory) {
      subCategory = {
        name: reportField.subcategory,
        key: subCategoryKey,
        items: [],
        formattedSearchText: formatSubCategoryName(
          category.name,
          reportField.subcategory,
        ),
      };
      category.items.push(subCategory);
      itemMap.set(subCategoryKey, subCategory);
    }

    const field = {
      key: reportFieldKey,
      name: reportField.fieldName,
      tag: reportField,
    } as SideNavCategory;
    subCategory.items.push(field);

    // All Category items
    insertSorted(allCategories, { ...field }, comparer);
  });

  // Append Custom Fields category
  if (customFieldSubCategory.items.length > 0) {
    insertSorted(categories, customFieldsCategory, comparer);
    insertSorted(allFieldsToSearch, customFieldsCategory, comparer);
  }

  // Create combination of all main categories
  // Including their subcategories for search purposes
  const searchableFields: SideNavCategory[] = [];
  allFieldsToSearch.forEach((field) => {
    field.items.forEach((x) => searchableFields.push(x));
  });

  // Create Searchable  category
  categories.unshift({
    key: 'Searchable',
    name: 'Searchable',
    items: searchableFields,
  });

  return categories;
}
